class Ajax {

    get(aFormKey, aData, aCallback) {
        
        let url = this.getURL();
        let data = aData || [];
        
        data.push({
            name : 'formKey',
            value : aFormKey
        });

        $.get(url, data, (transport) => {
            // --
        }).always((aData) => {

            let data = {};

            if (aData.responseJSON) {
                data = aData.responseJSON;
            } else {
                data = aData;
            }

            let result = this.evaluate(data);

            if (aCallback) {
                aCallback(result);
            }

        });

    }

    post(aFormKey, aData, aCallback) {

        let url = this.getURL();
        let data = aData || [];

        data.push({
            name : 'formKey',
            value : aFormKey
        });
        
        $.post(url, data, (transport) => {
        }).always((aData) => {

            let data = {};

            if (aData.responseJSON) {
                data = aData.responseJSON;
            } else {
                data = aData;
            }

            let result = this.evaluate(data);

            if (aCallback) {
                aCallback(result);
            }

        });
    }

    evaluate(transport) {

        let responseData = transport;

        if (responseData.actions) {
            
            this.evaluateAction(responseData);

            delete(responseData.actions);
        }

        return responseData;
    }

    evaluateAction (pData) {

        let actions = pData.actions;
        let formKey = pData.formKey;

        $.each(actions, function (index, action) {
            
            switch (action.method){
                
                case "error":
                    
                    let form = $('FORM[data-key="'+formKey+'"]');

                    if(form){

                        form.addClass('error');

                        let elements = form.find('[data-name="'+action.element+'"]');
                        elements.addClass('error');

                        let alert = form.find('.form-message .alert');
                        alert.html(action.information);

                    }
                    
                    
                    break;
                    
                case "load":
                    location.href = action.location;
                    break;    
                case "reload":
                    location.reload();
                    break;    
                case "insert":
                    $(action.selector).html(action.content);
                    break;    
                case "alert":
                    alert(action.information);
                    break;    
                case "delete":
                    $(action.element).remove();
                    break;    
                case "call":
                    // TODO : BAD, but how to do it without eval?
                    let callFunction = eval(action.name);

                    if (callFunction !== "undefined") {

                        let bindTarget = null;
                        if (action.name.split('.').size() > 0) {
                            let parts = action.name.split('.').slice(0, -1);
                            bindTarget = eval(parts.join('.'));
                        }

                        if (action.parms) {
                            callFunction.apply(bindTarget, parms);
                        } else {
                            callFunction();
                        }

                    } else {
                        this.log('Function not found!');
                    }
                    break;    
                case "class":
                    
                    let element = $(action.selector);
                    
                    if(element){

                        switch (action.type){
                            case"toggle":
                                element.toggleClass(action.class);
                                break;
                            case"add":
                                element.addClass(action.class);
                                break;
                            case"remove":
                                element.removeClass(action.class);
                                break;
                        }
                        
                    }
                    
                    break;    
                                
            }
            
        });


    }
    
    getURL(){
        return (location.href.indexOf('?')>-1 ? '/' : location.href ) + 'ajax.json';
    }
    
}

export default new Ajax();